export default function ExternalResourcesDirective() {
  return {
    template: require('./external-resources.html'),
    scope: {
      assessmentId: '=',
      status: '=',
      includePandemicPolicy: '=',
      includeKeyContacts: '=',
    },
    controller: 'ExternalResourcesController',
    controllerAs: 'externalResourcesVM',
    bindToController: true,
    replace: true,
  };
}
